import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
  Typography,
  Box
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

import { 
  CreateDBEWaitlistEntry 
} from '../../redux/actions/dbeWaitlistActions';

import "./styles.scss";

const Data = {
  company: '',
  email: '',
  volume: '',
  exposure: ''
};

const TradeSecureWaitlistPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState(Data);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {

      let obj = {
        name: "TRADE_SECURE",
        company: formData.company,
        email: formData.email,
        phone: formData.volume + ";" + formData.exposure,
      };

      await dispatch(CreateDBEWaitlistEntry(obj, setLoading));

      setFormData(Data);
      setSubmitted(true);
    } catch (error) {
      console.error('Lusid Audit submission failed:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="trade-secure">
      <div className="trade-secure__wrapper">

        {/* Header */}
        <div className="trade-secure__header">
          {/* <div className="trade-secure__logo">
            LusidPay <span>trade_secure</span>
          </div> */}
          {/* <div className="trade-secure__badge">Strictly Confidential</div> */}
          <h1 className="trade-secure__title">Enterprise Audit Defense</h1>
          <p className="trade-secure__subtitle">
            Currently accepting 5 Mid-to-Large Importers of Record for our Q2 Shadow Audit Program.
            Execute a CFR 19 deterministic ledger stress-test with zero disruption to your live CBP transmissions.
          </p>
        </div>

        {/* Form / Success Panel */}
        {submitted ? (
          <div className="trade-secure__success-screen">
            <Box className="trade-secure__success-content">
              <CheckCircleOutlineIcon className="trade-secure__success-icon" />
              <Typography variant="h5" className="trade-secure__success-title">
                Intake Secured
              </Typography>
              <Typography variant="body1" className="trade-secure__success-message">
                The LusidPay Engineering team will initiate the Exemption 4 data transfer protocol within 24 hours.
              </Typography>
              <Button
                variant="contained"
                className="trade-secure__success-btn"
                onClick={() => navigate('/')}
              >
                Return to Home
              </Button>
            </Box>
          </div>
        ) : (
          <div className="trade-secure__panel">
            <form className="trade-secure__form" onSubmit={handleSubmit}>

              <TextField
                label="Company Name (Importer of Record)"
                name="company"
                value={formData.company}
                onChange={handleInputChange}
                placeholder="e.g. Hitachi Energy"
                variant="outlined"
                fullWidth
                required
                disabled={loading}
              />

              <TextField
                label="Corporate Work Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="director@company.com"
                variant="outlined"
                fullWidth
                required
                disabled={loading}
              />

              <FormControl variant="outlined" fullWidth required disabled={loading}>
                <InputLabel id="volume-label">Annual Import Volume (USD)</InputLabel>
                <Select
                  labelId="volume-label"
                  name="volume"
                  value={formData.volume}
                  onChange={handleInputChange}
                  label="Annual Import Volume (USD)"
                >
                  <MenuItem value="" disabled><em>Select volume tier...</em></MenuItem>
                  <MenuItem value="under50">Under $50 Million</MenuItem>
                  <MenuItem value="50to500">$50 Million – $500 Million (Priority Queue)</MenuItem>
                  <MenuItem value="over500">$500 Million+ (Enterprise)</MenuItem>
                </Select>
              </FormControl>

              <FormControl variant="outlined" fullWidth required disabled={loading}>
                <InputLabel id="exposure-label">Primary CBP Enforcement Exposure</InputLabel>
                <Select
                  labelId="exposure-label"
                  name="exposure"
                  value={formData.exposure}
                  onChange={handleInputChange}
                  label="Primary CBP Enforcement Exposure"
                >
                  <MenuItem value="" disabled><em>Select primary risk vector...</em></MenuItem>
                  <MenuItem value="uflpa">UFLPA / Forced Labor Detentions</MenuItem>
                  <MenuItem value="section301">Section 301 / 232 Tariffs</MenuItem>
                  <MenuItem value="valuation">Part 152 Valuation &amp; Assists</MenuItem>
                  <MenuItem value="adcvd">AD/CVD (Antidumping)</MenuItem>
                  <MenuItem value="pga">PGA (FDA, EPA, TSCA)</MenuItem>
                </Select>
              </FormControl>

              <Button
                type="submit"
                variant="contained"
                fullWidth
                disabled={loading}
                className="trade-secure__submit-btn"
              >
                {loading ? (
                  <>
                    <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
                    Submitting...
                  </>
                ) : (
                  'Request Shadow Audit Allocation'
                )}
              </Button>
            </form>

            {/* Trust Markers */}
            <div className="trade-secure__trust">
              <span className="trade-secure__trust-item">Bank-grade encryption</span>
              <span className="trade-secure__trust-item">Multi-factor authentication</span>
              <span className="trade-secure__trust-item">Regular third-party audits</span>
            </div>
          </div>
        )}

        {/* Footer Note */}
        <p className="trade-secure__footer-note">
          Submission of this intake form establishes a mutual non-disclosure alignment.
          All ingested historical entry data is processed at the edge and legally classified as{' '}
          <strong>FOIA Exemption 4 / Confidential Commercial Information.</strong>
        </p>

      </div>
    </div>
  );
};

export default TradeSecureWaitlistPage;
